import { format, parseISO } from "date-fns"
import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    width: '35%',
    className: 'bold',
    render: (data, type, row, meta) => {
      const date = row['created_at'] ? format(parseISO(row['created_at'].replace(' ', 'T').replace(' UTC', 'Z')), "do MMMM yyyy, HH:mm") : ''
      const isDiscarded = row['discarded'] === 'true'
      const name = isDiscarded ? data : <a href={`/admin/flows/${row.DT_RowId}/overview`}>{data}</a>
      const tags = _.compact(decodeURIComponent(row['tags'] || '').split('||'))

      return renderToString(
        <div>
          {name}<br />
          <span className='small-text'>Created: {date}</span>
          {tags.length > 0 && <><br />
            {tags.map(tag => <span className='tag' key={tag}>{tag}</span>)}
          </>}
          {isDiscarded && <><br />
            <button className="button secondary small margin-top half restore-flow" data-flow-id={row.DT_RowId}>Restore page</button>
          </>}
        </div>
      )
    }
  },
  {
    data: 'wizard_name',
    width: '25%',
  },
  {
    data: 'status',
    width: '15%',
    render: function (data, type, row, meta) {
      function getClass() {
        const status = row['status']
        if (status === 'live') return 'accent'
        if (status === 'closed') return 'blue-100'

        return 'purple-60'
      }

      var status = row['status']

      return `<span class="bold ${getClass()} capitalize">${status}</span>`
    },
  },
  {
    data: 'stats',
    width: '30%',
    render: function (data, type, row, meta) {
      if (row['status'] === 'draft') {
        return '';
      } else {
        const statsData = typeof data === 'string' ? JSON.parse(data) : data;
        let output = '';
        statsData.forEach(([label, count]) => {
          if (label !== 'Redirect') {
            output += `<div class='horizontal-stat'><strong class="purple-80">${label}</strong><span>${count}</span></div>`;
          }
        });

        return output;
      }
    }
  },
  { data: 'created_at', visible: false },
  { data: 'slug', visible: false }
]

const headers = ['Name', 'Template', 'Status', 'Completions', 'Created', 'Slug']

const filters = [
  {
    name: 'Status', column: 2, kind: 'radio', options: [
      { value: 'draft', label: 'Draft' },
      { value: 'live', label: 'Live' },
      { value: 'paused', label: 'Paused' },
      { value: 'closed', label: 'Closed' }
    ]
  },
  { name: 'Using a template', kind: 'async', entity: 'flow_template' },
  { name: 'Tag', kind: 'async', entity: 'tag' },
  { name: 'Created by', kind: 'async', entity: 'user' },
]

const sorters = [
  { column: 4, label: 'Created', order: 'desc' },
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' }
]

const order = [[4, "desc"]]

export { columns, headers, filters, sorters, order }
